module.exports = __webpack_public_path__ + "static/img/living_3.75f00cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/living_3.jpg
// module id = x20y
// module chunks = 3